module.exports = __webpack_public_path__ + "static/img/image002.fa6fb3af.png";